import { styled } from '../../../styles/settings'

const SummaryItemLogo = styled.img`
  width: 1.5rem;
  height: 1.5rem;
`

export default SummaryItemLogo
